import { render, staticRenderFns } from "./UsersHealth.vue?vue&type=template&id=16c235f2&scoped=true&"
import script from "./UsersHealth.vue?vue&type=script&lang=ts&"
export * from "./UsersHealth.vue?vue&type=script&lang=ts&"
import style0 from "./UsersHealth.vue?vue&type=style&index=0&id=16c235f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c235f2",
  null
  
)

export default component.exports